/****************************************************
 * Module Name:  addEyecleanModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import EyecleanProxy from "../../utility/proxy/manager/eyecleanProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import Utility from "../../utility/utility";
import { Box, Button, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddEyecleanModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      neweyeclean: this.props.editOperation ? this.props.sourceData.name : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateEyecleanPresentSpinner: false,
      showValidationMessage: false,
      eyecleanAvailable: true,

      eyecleanValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.neweyeclean,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateEyecleanPresent = (eyecleanEntered) => {
    if (!eyecleanEntered || eyecleanEntered.trim() === "") return;

    this.setState({
      validateEyecleanPresentSpinner: true,
    });

    EyecleanProxy.CheckEyecleanAvailable(eyecleanEntered, (response) => {
      //if we got response that means eyeclean is present at backend
      if (response) {
        //EyecleanName already present
        this.setState({
          validateEyecleanPresentSpinner: false,
          showValidationMessage: true,
          eyecleanAvailable: false,
        });
      } else {
        //EyecleanName not available, so can be used
        this.setState({
          validateEyecleanPresentSpinner: false,
          showValidationMessage: true,
          eyecleanAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return !this.state.showValidationMessage || !this.state.eyecleanAvailable;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add eye clean validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Eye Clean"
                : "Add New Eye Clean"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Eyeclean Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Eyeclean <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.neweyeclean}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Eyeclean (required)"
                          placeholder="Enter Eyeclean"
                          value={this.state.neweyeclean}
                          autoFocus
                          onBlur={(e) =>
                            this.validateEyecleanPresent(this.state.neweyeclean)
                          }
                          onChange={(e) =>
                            this.setState({
                              neweyeclean: e.target.value,
                              showValidationMessage: false,
                              eyecleanValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Eyeclean Cannot be Empty",
                            })
                          }
                          helperText={this.state.eyecleanValidationError}
                          error={this.state.eyecleanValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateEyecleanPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.eyecleanAvailable ? (
                        <font color="green">Eyeclean available</font>
                      ) : (
                        <font color="red">Eyeclean not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
